import { Cap } from "../../../src/types/caps";
import { AppThunk } from "../store";
import { CapHistory } from "../../features/models/api/api-types";
import axios from "axios";
import { toCapHistory } from "../../utils/caps";

export const RECEIVE_HISTORY_CAP = "RECEIVE_HISTORY_CAP";
export const MAX_HISTORY_CAP = "MAX_HISTORY_CAP";

export type ReceiveCapHistoryAction = {
  type: typeof RECEIVE_HISTORY_CAP;
  data: CapHistory;
};

export type MaxHistoryAction = {
  type: typeof MAX_HISTORY_CAP;
  capID: number;
  capHistory: number;
};
const fetchHistory = async (
  capID: number,
  capHistory?: number
): Promise<CapHistory | null> => {
  let r = await axios.get<CapHistory>(
    `${`/api/v1/caps`}/${capID}`,
    {
      params: {
        capHistory: capHistory,
      },
    }
  );
  return toCapHistory(r.data);
};
export const getCapsHistory =
  (m: number, capHistory: number): AppThunk =>
  async (dispatch) => {
    try {
      const cap = await fetchHistory(m, capHistory);

      if (cap) {
        dispatch({ type: RECEIVE_HISTORY_CAP, data: cap });
      } else {
        dispatch({ type: MAX_HISTORY_CAP, capID: m, capHistory: capHistory - 1 });
      }
    } catch (err) {
      console.log("error", err);
      throw err;
    }
};
